module.exports = __webpack_public_path__ + "img/tile-onionskins_jp.fb139bd.jpg";